const volunteering = [
  {
    id: "winter",
    date: "06/2015 to 07/2015",
    company: "Winterbourne Junior Girls' School ",
    role: "Teaching Assistant",
  },

  {
    id: "hmrc",
    date: "01/2015 to 02/2015",
    company: "HM Revenue and Customs, Security and Information Directorate",
    role: "Business Management trainee ",
  },

  {
    id: "dwp",
    date: "11/2014 to 12/2014",
    company: "Department for Work and Pensions",
    role: "Business Support trainee",
  },

  {
    id: "sales",
    date: "01/2014 to 03/2014",
    company: "Pioneer Advertising/ Miami Marketing",
    role: "Sales Representative",
  },

  {
    id: "lab",
    date: "07/2012 to 08/2012",
    company: "Ghana Standards Authority",
    role: "Forensic, Drugs & Cosmetics Laboratory Assistant",
  },
];

export default volunteering;
